
import {
    FETCH_STORE_INFO_END
} from "../constants/ActionTypes";
import { MerchstoreAction } from "../reduxTypes";

export default function storeReducer(state = {
    status: "draft",
    customerAdmins: [],
    subdomain: "",
    storeLogo: "",
    bannerImage: "",
    storeMessage: "",
    revenue: 0,
    accentColor: "",
    merchologist: "",
    payerType: "",
    alwaysOpen: true,
    processingSchedule: "",
    nextProcessingDate: "",
    artworkOptions: [],
    shipToOffice: false,
    name: "",
    storeCode: ""

}, action: MerchstoreAction) {

    const type = action.type;
    const merchstore = action.merchstore;

    switch (type) {
        case FETCH_STORE_INFO_END:
            return { ...merchstore }
        default:
            return state;
    }

}